import { createColumnHelper, SortingFn } from '@tanstack/react-table'
import { Link } from 'react-router-dom'
import { Badge } from 'reactstrap'
import { yesno } from 'src/helpers/displayhelpers'
import { StaffingAgencies } from 'src/queries'

type TData = StaffingAgencies[0]

const columnHelper = createColumnHelper<TData>()

export type Columns = Array<ReturnType<typeof columnHelper.accessor>>

type SortByArrayFn = (arr: string[]) => SortingFn<TData>

const sortByArray: SortByArrayFn = (arr) => (aRow, bRow, columnId) => {
  const aVal = aRow.getValue(columnId)
  const bVal = bRow.getValue(columnId)
  const a = arr.indexOf(String(aVal))
  const b = arr.indexOf(String(bVal))
  return a - b
}

const columns = (statuses: string[]): Columns => ([
  columnHelper.accessor('name', {
    id: 'name',
    header: 'Name',
    cell: (info) => {
      const value = info.getValue()
      const id = info.row.original._id
      const name = ['', null, undefined].includes(value) ? '(No Name)' : value
      if (id !== undefined) {
        return (
          <Link to={`/cat/staffingagencies/${String(id)}`}>{name}</Link>
        )
      }
      return value
    }
  }),
  columnHelper.accessor('_status.name', {
    id: 'status',
    header: 'Status',
    sortingFn: sortByArray(statuses),
    cell: (info) => {
      const val = info.getValue()
      const color = info.row.original._status?.color ?? 'light'
      const textColor = color === 'light' ? 'text-dark' : ''
      return (
        <Badge color={color} className={`${textColor} w-100`}>{val}</Badge>
      )
    }
  }),
  columnHelper.accessor('staffingAgency.sdvosb', {
    id: 'sdvosb',
    header: 'SDVOSB',
    cell: (info) => {
      const value = info.getValue()
      return yesno(value)
    }
  }),
  columnHelper.accessor('position_count', {
    header: 'Open Positions',
    cell: (info) => {
      const value = info.getValue()
      if (value === null || value === undefined || value === 0) {
        return ''
      }
      return `${String(value) ?? ''} Open`
    }
  })
])

export { columns }
